// Práce bez signálu (rozhodnutí uživatele 2026-10-31) — pomocné funkce pro
// supabase-layer.js (bez závislosti na zbytku aplikace):
//  - IndexedDB „bozp-offline“: poslední načtená data tabulek (cache) a fotky,
//    které ještě nejsou nahrané (photos);
//  - fronta neodeslaných zápisů (outbox, localStorage) — pořadí se zachová,
//    opakované úpravy stejného řádku se slučují;
//  - rozpoznání chyby sítě (bez signálu, vypršení času).
var DB_NAME = 'bozp-offline', DB_VER = 1;
var dbPromise = null;
function openDb(){
  if(dbPromise) return dbPromise;
  dbPromise = new Promise(function(resolve){
    try{
      var req = indexedDB.open(DB_NAME, DB_VER);
      req.onupgradeneeded = function(){
        var d = req.result;
        if(!d.objectStoreNames.contains('cache')) d.createObjectStore('cache');
        if(!d.objectStoreNames.contains('photos')) d.createObjectStore('photos');
      };
      req.onsuccess = function(){ resolve(req.result); };
      req.onerror = function(){ resolve(null); };
      req.onblocked = function(){ resolve(null); };
    }catch(e){ resolve(null); }
  });
  return dbPromise;
}
function tx(store, mode, fn){
  return openDb().then(function(d){
    if(!d) return null;
    return new Promise(function(resolve){
      try{
        var t = d.transaction(store, mode), s = t.objectStore(store), out = fn(s);
        t.oncomplete = function(){ resolve(out && 'result' in out ? out.result : null); };
        t.onerror = t.onabort = function(){ resolve(null); };
      }catch(e){ resolve(null); }
    });
  });
}
export var idb = {
  get: function(store, key){ return tx(store, 'readonly', function(s){ return s.get(key); }); },
  put: function(store, key, val){ return tx(store, 'readwrite', function(s){ s.put(val, key); }); },
  del: function(store, key){ return tx(store, 'readwrite', function(s){ s.delete(key); }); },
  clear: function(store){ return tx(store, 'readwrite', function(s){ s.clear(); }); },
  all: function(store){
    return openDb().then(function(d){
      if(!d) return [];
      return new Promise(function(resolve){
        var out = [];
        try{
          var req = d.transaction(store, 'readonly').objectStore(store).openCursor();
          req.onsuccess = function(){ var c = req.result; if(c){ out.push({key: c.key, value: c.value}); c.continue(); } else resolve(out); };
          req.onerror = function(){ resolve(out); };
        }catch(e){ resolve(out); }
      });
    });
  }
};

// Chyba sítě = zápis zkusit znovu později (ne chyba oprávnění nebo dat).
export function isNetworkError(err){
  if(typeof navigator !== 'undefined' && navigator.onLine === false) return true;
  if(!err) return false;
  if(err.code && String(err.code).length && !/^(ETIMEDOUT|ECONNRESET|20)$/.test(String(err.code))) return false; // Postgres/PostgREST kód = odpověď serveru
  var msg = String(err.message || err.details || err || '');
  return /Failed to fetch|Load failed|NetworkError|network|fetch failed|timeout|aborted|AbortError/i.test(msg);
}
export function isOffline(){ return typeof navigator !== 'undefined' && navigator.onLine === false; }

// Promise s časovým limitem — slabý signál umí požadavek nechat viset.
export function withTimeout(promise, ms, abort){
  var timer;
  return Promise.race([
    promise,
    new Promise(function(resolve){ timer = setTimeout(function(){ if(abort) try{ abort(); }catch(e){} resolve({data: null, error: {message: 'timeout'}}); }, ms); })
  ]).then(function(r){ clearTimeout(timer); return r; }, function(e){ clearTimeout(timer); return {data: null, error: e}; });
}

// ---------- fronta zápisů ----------
// Položka: {seq, uid, table, id, op:'merge'|'set'|'delete', patch, remove, data}.
// Položka, která se právě odesílá (sending), se už neslučuje — nová úprava
// jde za ni, jinak by se po odeslání smazala i s neodeslanou změnou.
var seqBase = Date.now(), seqN = 0, sending = null;
var OUTBOX_KEY = 'bozp-outbox-v1';
function readOutbox(){
  try{ var v = JSON.parse(localStorage.getItem(OUTBOX_KEY) || '[]'); return Array.isArray(v) ? v : []; }catch(e){ return []; }
}
function writeOutbox(list){
  try{ if(list.length) localStorage.setItem(OUTBOX_KEY, JSON.stringify(list)); else localStorage.removeItem(OUTBOX_KEY); return true; }
  catch(e){ return false; }
}
export var outbox = {
  list: function(uid){ return readOutbox().filter(function(it){ return it.uid === uid; }); },
  count: function(uid){ return outbox.list(uid).length; },
  // Přidá zápis; úprava řádku, který už ve frontě čeká, se do něj sloučí.
  add: function(item){
    var list = readOutbox();
    item.seq = seqBase + (++seqN);
    if(item.op === 'merge'){
      for(var i = list.length - 1; i >= 0; i--){
        var it = list[i];
        if(it.uid !== item.uid || it.table !== item.table || it.id !== item.id) continue;
        if(it.seq === sending) break;
        if(it.op === 'merge'){
          (item.remove || []).forEach(function(k){ delete it.patch[k]; if(it.remove.indexOf(k) < 0) it.remove.push(k); });
          Object.keys(item.patch).forEach(function(k){ it.patch[k] = item.patch[k]; var r = it.remove.indexOf(k); if(r >= 0) it.remove.splice(r, 1); });
          return writeOutbox(list);
        }
        if(it.op === 'set'){
          (item.remove || []).forEach(function(k){ delete it.data[k]; });
          Object.keys(item.patch).forEach(function(k){ it.data[k] = item.patch[k]; });
          return writeOutbox(list);
        }
        break; // delete → nový zápis za ním
      }
    }
    list.push(item);
    return writeOutbox(list);
  },
  setSending: function(seq){ sending = seq; },
  // Odstraní položku (po úspěšném odeslání nebo zamítnutí serverem).
  remove: function(seq){
    var list = readOutbox().filter(function(it){ return it.seq !== seq; });
    writeOutbox(list);
  }
};
// Zápis z fronty promítnutý do načtených řádků (data, která aplikace vidí).
export function applyItem(rows, it){
  if(it.op === 'delete'){ rows.delete(it.id); return; }
  if(it.op === 'set'){ rows.set(it.id, JSON.parse(JSON.stringify(it.data))); return; }
  var cur = Object.assign({}, rows.get(it.id) || {});
  (it.remove || []).forEach(function(k){ delete cur[k]; });
  Object.keys(it.patch || {}).forEach(function(k){ cur[k] = it.patch[k]; });
  rows.set(it.id, JSON.parse(JSON.stringify(cur)));
}
